<template>
  <div class="flex full-height">
    <el-col :span="8" v-loading="localGetAgentsStatus === 'loading'">
      <el-row class="list-summary">
        <el-col :span="12">
          <span class="body2" v-if="!networkHosts">None</span>
          <span
            class="body2"
            v-if="networkHosts.length > 0"
          >{{`1-${networkHosts.length} of ${networkHosts.length}`}}</span>
        </el-col>
      </el-row>
      <el-row class="c-table">
        <div
          v-if="networkHostsLoaded"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
          infinite-scroll-distance="10"
          style="overflow:auto;"
          id="agentvlist"
          :key="agentvlistKey">
            <div
              class="flex column c-table_row"
              v-for="(val, idx) in range(0,networkHostCount)"
              :key="idx"
              :class="{'active': networkHostList[val].selected}"
              @click.stop.prevent="highlightNode(networkHostList[val], $event)"
              style="{width: 100%, 'max-height':'60px', 'padding': '2px 0px'}"
            >
              <agent-info-card :agent="networkHostList[val]"/>
            </div>
        </div>
      </el-row>
      <footer>
        <router-link to="/hosts" class="float-right cursor-pointer">
          <span class="box text-button uppercase">view all -></span>
        </router-link>
      </footer>
    </el-col>
    <el-col :span="16" class="scrollable only-y" v-if="hostmapInfoReqStatus === 'saved'">
      <d3-hostmap-topology
        ref="topology"
        :chart-data="hostmapInfo"
        @node-click="hostMapClick"
        @update-chartdata="updateHostmapInfo"
      ></d3-hostmap-topology>
    </el-col>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { mapGetters } from "vuex";
import { AGENT_LIST_REQ } from "@/store/modules/agents/agents.type";
import {
  HOSTMAP_INFO_LIST_REQ,
  HOSTMAP_INFO_LIST_SUCCESS,
  HOSTMAP_INFO_UPDATE_LIST_REQ
} from "@/store/modules/hostmap_info/hostmap_info.type";

import D3HostmapTopology from "@/components/network-graph/D3HostmapTopology.vue";
import AgentInfoCard from "@/components/card/AgentInfoCard.vue";

import {
  findNodesForRemoval,
  findNewNodes
} from "@/utilities/d3network.helper";
import { registerInverval, destroyInverval } from "@/utilities/global.interval";
import { DASHBOARD_POLLING_INTERVAL } from "@/constants/polling-interval.constants";
import { DATETIME_STATS_DISPLAY_FORMAT } from "@/constants/datetime.constants";

export default {
  name: "AgentsSecurityPostureDashboard",
  data() {
    return {
      networkHosts: {},
      agentsIntervalId: {},
      localGetAgentsStatus: "loading",
      localHostmapInfoReqStatus: "loading",
      highlightNode: {},
      networkHostCount: 0,
      networkHostsLoaded: false,
      networkHostList: [],
      agentvlistKey: 0  // key used to re-render trails list
    };
  },
  mounted() {
    // window resize event
    let debounceResize = _.debounce(
      this.forceRerenderList,
      500
    );

    window.addEventListener("resize", debounceResize);
  },
  created() {
    if (
      this.agentListReqStatus === "saved" &&
      this.hostmapInfoReqStatus === "saved"
    ) {
      this.networkHosts = _.cloneDeep(this.agentList.models);
      this.localGetAgentsStatus = "saved";
      this.networkHostsLoaded = true; 
      this.setListHeight();
    } else {
      this.getAgentListInfo();
    }

    if (_.isEmpty(this.agentsIntervalId)) {
      this.$nextTick(function() {
        this.updateAgent();
      });
    }

    this.highlightNode = this.$_.debounce(agent => {
      agent.selected = true;
      this.unselectAgents(agent);
      let elem = document.getElementsByClassName(`host_${agent.agentId}`);
      this.$refs["topology"].clearNodeClasses(["active"]);
      if (!this.$_.isEmpty(elem)) {
        elem[0].classList.add("active");
        this.$refs["topology"].addLinkGroupClass(agent.customHostname, [
          "active"
        ]);
      }
    }, 250);
  },
  methods: {
    resetNetworkHostListData () {
      this.networkHostList = []
      this.networkHostCount = 0;
      this.networkHostsLoaded = true;
    },
    forceRerenderList () {
      this.agentvlistKey += 1;
      this.setListHeight()
    },
    setListHeight () {
      setTimeout(() => {
        const listElement = document.getElementById('agentvlist')
        const listHeight = this.$parent.$el.clientHeight-96;
        listElement.style.height = `${listHeight}px`;
      })
    },
    range (start, end) {
      let rangeArr = []
      for(let i = start; i < end; i++) {
        rangeArr.push(i);
      }
      return rangeArr; 
    },
    load () {
      this.networkHostList.push(this.networkHosts[this.networkHostCount])
      this.networkHostCount += 1
    },
    hostMapClick(nodeName) {
      let agent = _.find(this.networkHosts, { customHostname: nodeName.name });
      this.unselectAgents({});
      if (agent) {
        agent.selected = true;
        //scroll to agent element in the list
        let elem = this.$el.querySelector(
          `.agent-card_${agent.customHostname}`
        );
        if (elem) {
          elem.scrollIntoView({
            behavoir: "smooth",
            block: "nearest",
            inline: "nearest"
          });
        }
      }
    },
    unselectAgents(row) {
      this.networkHosts.forEach((agent, idx) => {
        if (agent.agentId !== row.agentId) {
          this.$set(this.networkHosts[idx], "selected", false);
        }
      });
    },
    getAgentListInfo() {
      this.$store.dispatch(AGENT_LIST_REQ).then(agents => {
        agents.models.sort((a, b) => {
          return a.agentId - b.agentId;
        });
        this.networkHosts = _.cloneDeep(agents.models);
        this.localGetAgentsStatus = "saved";

        this.$store.dispatch(HOSTMAP_INFO_LIST_REQ).then(hostmap => {
          this.$store.dispatch(HOSTMAP_INFO_LIST_SUCCESS);
          this.localHostmapInfoReqStatus = "saved";
        });
        this.networkHostsLoaded = true; 
        this.setListHeight();
      });
    },
    updateHostmapInfo(timeRange) {
      // this.localHostmapInfoReqStatus = "loading";
      this.$store
        .dispatch(HOSTMAP_INFO_UPDATE_LIST_REQ, {
          starttime: timeRange.starttime,
          endtime: timeRange.endtime
        })
        .then(hostmap => {
          this.$store.dispatch(HOSTMAP_INFO_LIST_SUCCESS);

          setTimeout(() => {
            this.$refs["topology"].animate(this.hostmapInfo);
          });

          // this.localHostmapInfoReqStatus = "saved";
        });
    },
    updateAgentInfo() {
      this.$store.dispatch(AGENT_LIST_REQ).then(agents => {
        this.mapUpdatedAgentInfo(agents.models);
      });
    },
    updateAgent() {
      this.agentsIntervalId = setTimeout(() => {
        this.updateAgentInfo();

        this.$nextTick(function() {
          this.updateAgent();
        });

        // communicate to parent to update summary details
        this.$parent.$parent.$emit("updateDashboardView");
      }, DASHBOARD_POLLING_INTERVAL);

      registerInverval(this.agentsIntervalId);
    },
    mapUpdatedAgentInfo(agents) {
      let removedNodes = findNodesForRemoval(
        agents,
        this.networkHosts,
        "agentId"
      );
      let newNodes = findNewNodes(agents, this.networkHosts, "agentId", [
        "_cssClass"
      ]);

      // update existing node info {size, color, riskscore}
      newNodes.updated.forEach(node => {
        if (
          this.networkHosts[node.index].aggregatedRiskScore !==
          node.obj.aggregatedRiskScore
        ) {
          this.$set(
            this.networkHosts,
            node.index,
            _.assignIn(this.networkHosts[node.index], {
              aggregatedRiskScore: node.obj.aggregatedRiskScore
            })
          );
        } else {
          node.obj.display = this.networkHosts[node.index].display;
          _.assignIn(this.networkHosts[node.index], node.obj);
        }
      });

      // append new nodes to the end of the list
      newNodes.added.forEach(insertIdx => {
        this.networkHosts.nodes.splice(insertIdx.index, 0, insertIdx.newObject);
      });

      // remove node (removal index is exclusive of new node indexes)
      removedNodes.forEach(removalIdx => {
        this.networkHosts.nodes.splice(removalIdx, 1);
      });
    }
  },
  computed: {
    ...mapGetters([
      "agentListReqStatus",
      "agentList",
      "hostmapInfo",
      "hostmapInfoReqStatus"
    ]),
    disabled () {
      return this.networkHostCount >= this.networkHosts.length
    }
  },
  components: {
    AgentInfoCard,
    D3HostmapTopology
  },
  watch: {
    networkHosts: function(newList, oldList) {
      if (newList !== oldList && newList.length > 0) {
        //run once to force virtuallist to render
        this.$nextTick(function() {
          this.resetNetworkHostListData()
          this.forceRerenderList()
        });
      }
    }
  },
  beforeDestroy() {
    // use empty function to kill interval update calls (timing insurance)
    this.updateAgent = (function() {
      return;
    })();
    // kill interval calls
    destroyInverval(this.agentsIntervalId);
  }
};
</script>

<style scoped>
@import "assets/styles/_variables.css";

.list-summary {
  .el-col {
    > span {
      margin-left: 16px;
      line-height: 40px;
    }
  }
}

.c-table_row {
  padding: 12px 10px;
  border-top: 1px solid var(--table-border-color);

  &:last-of-type {
    border-bottom: 1px solid var(--border-color);
  }

  &:hover {
    background-color: var(--aluminum-100);
  }

  &.active {
    width: 95%;
    margin-left: 1%;
    border-top: none;

    &:hover {
      background-color: inherit;
    }

    > div {
      box-sizing: border-box;
      padding: 8px;
      border-top: 1px solid var(--table-border-color);
      box-shadow: 2px 2px 12px 2px rgba(0, 0, 0, 0.1);
      &:hover {
        background-color: var(--aluminum-100);
      }
    }
  }
}

.item-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.c-table {
  height: 75%;
  margin-left: 10px;
}

footer {
  position: fixed;
  bottom: 10px;
  margin-left: 20%;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/AgentsSecurityPostureDashboard.vue